export default __webpack_public_path__ + "static/media/mobile_step_3_En.150c7cc7.jpg";